import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { House, BookOpen, Info, ChatCircleDots, User, ClockCounterClockwise, Bell, RadioButton } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const TABS = [
  { key: "home", label: "Beranda", icon: House, path: "/" },
  { key: "belajar", label: "Belajar", icon: BookOpen, path: "/belajar" },
  { key: "radio", label: "Kajian Parenting", icon: RadioButton, path: "/radio" },
  { key: "pesan", label: "Pesan", icon: ChatCircleDots, path: "/pesan" },
  { key: "profil", label: "Profil", icon: User, path: "/profil" },
];

const GURU_TABS = [
  { key: "home", label: "Beranda", icon: House, path: "/" },
  { key: "riwayat", label: "Riwayat", icon: ClockCounterClockwise, path: "/riwayat" },
  { key: "radio", label: "Kajian Parenting", icon: RadioButton, path: "/radio" },
  { key: "notif", label: "Notifikasi", icon: Bell, path: "/" },
  { key: "profil", label: "Profil", icon: User, path: "/profil" },
];

export function BottomNav() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { user } = useAuth();
  const isGuru = user && user.role === "guru";
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!isGuru) return;
    const load = () => api.get("/teacher/notifications").then((r) => setUnread(r.data.unread || 0)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [isGuru, pathname, search]);

  let tabs;
  if (isGuru) {
    tabs = GURU_TABS;
  } else {
    // admin: relabel Belajar -> Kelola
    tabs = TABS.map((t) =>
      t.key === "belajar" && user && user.role !== "orangtua"
        ? { ...t, label: "Kelola", path: "/kelola" }
        : t
    );
  }

  const notifActive = new URLSearchParams(search).get("notif") === "1";

  return (
    <nav className="absolute bottom-0 left-0 right-0 bg-white/85 backdrop-blur-xl border-t border-stone-200/60 px-4 pt-2 pb-3 flex justify-between items-center z-50">
      {tabs.map((t) => {
        const active = t.key === "notif" ? notifActive : (pathname === t.path && !notifActive);
        const Icon = t.icon;
        const showDot = t.key === "notif" && isGuru && unread > 0;
        return (
          <button
            key={t.key}
            data-testid={`bottom-nav-${t.key}`}
            onClick={() => navigate(t.key === "notif" ? "/?notif=1" : t.path)}
            className="flex flex-col items-center gap-0.5 flex-1 active:scale-90 transition-transform"
          >
            <span className="relative">
              <Icon
                size={24}
                weight={active ? "fill" : "regular"}
                className={active ? "text-primary" : "text-stone-400"}
              />
              {showDot && (
                <span data-testid="bottom-nav-notif-dot" className="absolute -top-0.5 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full ring-2 ring-white" />
              )}
            </span>
            <span className={`text-[10px] font-semibold leading-tight text-center ${active ? "text-primary" : "text-stone-400"}`}>
              {t.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
